import { useSelector } from 'react-redux';
import { IApplicationState } from '../../../state';

interface IBusinessPremiumAndE1NPGrantSunsetEnabled {
  isBusinessPremiumAndE1NPGrantSunsetEnabled: boolean;
}

const useBusinessPremiumAndE1NPGrantSunset = (): IBusinessPremiumAndE1NPGrantSunsetEnabled => {
  const isBusinessPremiumAndE1NPGrantSunsetEnabled = useSelector((state: IApplicationState) => state.flags.BusinessPremiumAndE1NPGrantSunsetEnabled);
  return {
    isBusinessPremiumAndE1NPGrantSunsetEnabled
  };
};

export default useBusinessPremiumAndE1NPGrantSunset;
